export default __webpack_public_path__ + "static/media/LegislatorCardBG.802ae097.jpg";